import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastComponent, ToastService } from '@pearsonvue/topaz-angular-ui';

export interface ToastData {
  url: string;
}

@Component({
  selector: 'app-toast-success',
  standalone: false,
  templateUrl: './toast-success.component.html',
  styleUrl: './toast-success.component.scss'
})

export class ToastSuccessComponent implements OnInit {
  @ViewChild(ToastComponent, { static: true }) public toast!: ToastComponent;
  public data!: ToastData;
  isCopied: boolean = false;
  constructor(private toastService: ToastService<ToastData>) { }
  ngOnInit(): void {
    this.data = this.toastService.getToastData(this.toast);
  }

  public close(): void {
    this.toastService.close(this.toast);
  }
  

  handleCopy() {
    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 2000);
  }
}
